import type { IOfferVisitSSO, IOfferVisitSSORequest } from '~/types/offer.visit.sso.types'
import type { SSO_DESTINATION } from '~/types/sso.config.types'
import { acceptHMRUpdate, defineStore } from 'pinia'

export const useOfferVisitsStore = defineStore('offerVisits', () => {
  // #region state
  const offerVisit = ref<IOfferVisitSSO>()
  // #endregion

  // #region actions
  const postOfferVisit = async (offerId: string, offerVisitSSORequest: IOfferVisitSSORequest) => {
    const visit = await platformApi.postVisitSSO(
      offerId,
      {
        memberId: offerVisitSSORequest.memberId as string,
        ssoDestination: offerVisitSSORequest.ssoDestination as SSO_DESTINATION,
        ssoAccessToken: offerVisitSSORequest.ssoAccessToken,
        referredFromRedemptionInstructions: offerVisitSSORequest.referredFromRedemptionInstructions,
      },
    )
    offerVisit.value = visit
  }
  // #endregion

  return {
    offerVisit,
    postOfferVisit,
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useOfferVisitsStore as any, import.meta.hot))
